export enum EActionTypes {
  GET_LANGUAGES = 'GET_LANGUAGES',
  GET_TRANSLATIONS = 'GET_TRANSLATIONS',
  CHANGE_LANGUAGE = 'CHANGE_LANGUAGE',
}
